import { OnsiteTriggers, TriggersConfigMap, TriggerType } from 'sections/onsite-campaigns/types';

export function mapTriggersToState(triggers?: OnsiteTriggers): TriggersConfigMap {
  const mapped: TriggersConfigMap = {
    [TriggerType.ExitIntent]: {
      active: triggers?.exitFrame?.length > 0,
      value: triggers?.exitFrame || [],
    },
    [TriggerType.Inactivity]: {
      active: !isNaN(triggers?.inactivity),
      value: (triggers?.inactivity || 0) / 1000,
    },
  };

  // Only include new triggers if they're present in the backend response
  if (triggers?.onLoad !== undefined) {
    mapped[TriggerType.PageLoad] = {
      active: triggers.onLoad === true,
      value: triggers.onLoad,
    };
  }

  if (triggers?.onClick !== undefined) {
    mapped[TriggerType.OnClick] = {
      active: !!triggers.onClick?.selector,
      value: {
        selector: triggers.onClick?.selector || '',
        overrideFreqCaps: triggers.onClick?.overrideFreqCaps ?? true,
      },
    };
  }

  return mapped;
}
